import NsContent from 'components/common/ns-content/NsContent';
import NsColumn from '@britishgasenergy/react-nucleus/dist/nuc-components/NsColumn';

import { NsTitle } from 'components/common/ns-title/NsTitle';
import { NsBackCta } from 'components/common/ns-back-cta/NsBackCta';
import { NsPanel } from 'components/common/ns-panel/NsPanel';
import { NsPrimaryCta } from 'components/common/ns-primary-cta/NsPrimaryCta';
import { NonSupplyInfo } from 'components/direct-sales/non-supply/components/NonSupplyInfo';
import { useResponsive } from 'hooks/useResponsive';
import { useNavigation } from 'hooks/useNavigation';

export const testId = 'nonSupplyTestId';

export const NonSupply = () => {
  const { isMobile } = useResponsive();
  const { next, eventTypes } = useNavigation();

  const handleGoNext = () => {
    next({ eventType: eventTypes.NEXT });
  };

  return (
    <NsPanel testId={testId}>
      <NsContent>
        <NsBackCta />
        <NsTitle title="We’d love to supply your new home" />
      </NsContent>
      <NsColumn basketballcourt="2" hockeypitch="2:1">
        <NsContent>
          <h3>We don’t supply your new home, but it’s easy to switch</h3>
          <p>
            Just let us know the tariff you want, when you’d like your supply to
            start and how you’d like to pay and we’ll take care of the rest.
          </p>
          <NonSupplyInfo shouldShow={isMobile} />
          <NsPrimaryCta onClick={handleGoNext}>
            Let’s get you a new energy quote
          </NsPrimaryCta>
        </NsContent>
        <NsContent>
          <NonSupplyInfo shouldShow={!isMobile} />
        </NsContent>
      </NsColumn>
    </NsPanel>
  );
};

export default NonSupply;
